import type { ColumnFormat } from "../types/column-format";

export const isNumberType = (
  format: ColumnFormat | null | undefined,
): boolean =>
  format != null &&
  (format.kind === "NUMBER" ||
    format.kind === "NUMBER_PLAIN" ||
    format.kind === "PERCENT" ||
    format.kind === "CURRENCY");

export const isDateType = (
  format: ColumnFormat | null | undefined,
): format is Extract<ColumnFormat, { kind: "DATE" }> => format?.kind === "DATE";

export const isTextType = (format: ColumnFormat | null | undefined): boolean =>
  format != null &&
  (format.kind === "TEXT" ||
    format.kind === "EMAIL" ||
    format.kind === "URL" ||
    format.kind === "IMAGE" ||
    format.kind === "ENUM");

export const isBooleanType = (
  format: ColumnFormat | null | undefined,
): boolean => format?.kind === "BOOLEAN";

export const isJsonType = (format: ColumnFormat | null | undefined): boolean =>
  format?.kind === "OBJECT" || format?.kind === "ARRAY";

export const isEnumType = (format: ColumnFormat | null | undefined): boolean =>
  format?.kind === "ENUM";

export const isEmpty = (value: unknown) =>
  value === "" || value === null || value === undefined;
